const DrawerInitiator = {
  init({ button, drawer, content }) {
    button.addEventListener('click', (event) => {
      this._toggleDrawer(event, drawer);
    });

    content.addEventListener('click', (event) => {
      this._closeDrawer(event, drawer);
    });
  },

  _toggleDrawer(event, drawer) {
    drawer.classList.toggle('show');
    event.stopPropagation();
  },

  _closeDrawer(event, drawer) {
    drawer.classList.remove('show');
    event.stopPropagation();
  },
};

export default DrawerInitiator;
